import axios from 'axios'
import { get_cookie } from 'shared/lib/cookie'
import { getClientIpAddress } from 'shared/lib/getClientIpAddress'
import { logger } from 'shared/lib/logger'
import { showToast } from 'shared/ui'

type HubspotFormField = {
  name: string
  value: string | number
}

type HubspotFormContext = Record<string, string | number | boolean | undefined>

type ISubmitDataToHubspotFormProps = {
  portalId: string
  formId: string
  fields?: HubspotFormField[]
  context?: HubspotFormContext
  successCallback?: () => void
  errorCallback?: () => void
  finallyCallback?: () => void
  isShowErrorMessage?: boolean
}

export const submitDataToHubspotForm = async ({
  portalId,
  formId,
  fields,
  context,
  successCallback,
  errorCallback,
  finallyCallback,
  isShowErrorMessage,
}: ISubmitDataToHubspotFormProps) => {
  const ipAddress = await getClientIpAddress()
  const hubspotUtk = get_cookie('hubspotutk')

  try {
    await axios.post(
      `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
      {
        fields,
        context: {
          pageUri: window.location.href,
          pageName: document.title,
          ...(ipAddress && { ipAddress }),
          ...(hubspotUtk && { hutk: hubspotUtk }),
          ...context,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    successCallback?.()
  } catch (error) {
    logger.error(error)
    if (isShowErrorMessage) {
      showToast({
        type: 'error',
        title: 'Something went wrong. Please try again',
        desc: error instanceof Error ? error.message : undefined,
      })
    }
    errorCallback?.()
  } finally {
    finallyCallback?.()
  }
}
